import { FAQAccordionItem } from 'routes/components/Shared/Accordion'

export const pricingFaqData: FAQAccordionItem[] = [
  {
    question: 'How is an Active Customer defined and counted?',
    answer:
      'An active customer is anyone who has been using your integrations implemented with Integration App for 30 days or more. After this initial period, they count toward your usage metrics.',
  },
  {
    question: 'How does the pricing cap work?',
    answer:
      "Your usage fees increase with the number of Active Customers, but only up to a point. Once you reach a volume threshold, the cost stops increasing—you won't pay more no matter how much your usage grows after that. This prevents unlimited cost scaling as your business expands.",
  },
  {
    question: 'Are the API calls really unlimited?',
    answer:
      'Yes. We charge a flat fee per active customer per month, with no extra costs for API calls or other usage metrics. This gives you simple, predictable pricing without unexpected costs as your usage grows.',
  },
  {
    question: "What's included in the platform fee vs. usage fee?",
    answer:
      'The platform fee covers your selected features, support level, and number of available integrations. The usage fee is a simple cost per Active Customer per month.',
  },
  {
    question:
      'How does your customer-based pricing work with multiple users and integrations?',
    answer:
      'We charge per customer, not per integration instance, seat, or users. For example, if multiple employees at the same company use your Salesforce integration, that counts as just one Active Customer. Similarly, if a customer connects to multiple systems (for example, both Salesforce and HubSpot), they still count as only one customer.',
  },
  {
    question:
      'What happens when we need to add more integrations mid-contract?',
    answer:
      'You can add more integrations to your Platform Plan anytime, the costs will be prorated for the remainder of your contract term.',
  },
  {
    question:
      'What level of customer support is included in each pricing plan?',
    answer:
      'Our Starter Plan provides essential email and in-app chat support. The Pro plan adds real-time Slack support and implementation services, while the Ultimate plan offers dedicated real-time support. Integration App was recognized for "Best Support" by G2 in 2025, reflecting our commitment to exceptional customer service across all plans.',
  },
  {
    question: 'Do you have startup discounts?',
    answer:
      'We offer special startup discounts for early-stage companies with less than $1M in funding.',
  },
  {
    question: 'How do you compare to competitors on pricing?',
    answer:
      "Unlike competitors who let costs grow indefinitely with usage, we cap your expenses as you scale. We're designed to be a sustainable long-term solution rather than a temporary fix.",
  },
  {
    question: "What's included in your POC offering?",
    answer:
      "The POC program is completely free. We'll help you build a working prototype of your integrations, validate requirements, and make a confident go/no-go decision for your product integration needs.",
  },
  {
    question: 'What happens if I stop using Integration App?',
    answer:
      'Everything you build with us is highly transparent and portable. You have full access to your integration logic, connectors, customer configurations and credentials.If you decide to move part or all of your integrations elsewhere – you can do it. There is no vendor lock-in.',
  },
]
